import * as React from 'react';

import HistorySection from '../../../../../../components/HistorySection';
import HistoryRowVerticalItem from '../../../../../../components/HistoryRowVerticalItem';

import { formatPartialDate } from 'Utility/date';
import { newButton } from '../../../../utils/functions';
import { isNil } from 'Utility/ramdaReplacement';
import { IHistoryContext } from '../../../../../../containers/FormContextHandler';
import { editHistoryMenuItems } from 'Components/HistoryRowControls/EditHistory/EditHistoryDialog';

const MgravisSymptoms = ({
  documents = [],
  startEdit,
  fm = (): string => '',
}: IHistoryContext<IMGravisSymptoms>): React.JSX.Element => {
  const mgravisSymptoms = documents[0];

  return (
    <HistorySection
      headerText={fm('diagnosis.mgravis.symptoms.title')}
      hasHistoryRows={false}
      newButton={
        startEdit
          ? newButton(
              'mgravisSymptoms',
              startEdit(mgravisSymptoms ?? {}, 'mgravisSymptoms'),
              'general.edit',
              undefined,
              true,
              !isNil(((mgravisSymptoms ?? {}) as IControlProps)._lockedFor),
              undefined,
              undefined,
              mgravisSymptoms,
            )
          : undefined
      }
      menuItems={editHistoryMenuItems(mgravisSymptoms)}
    >
      <React.Fragment>
        <HistoryRowVerticalItem
          header={fm('general.date')}
          value={
            mgravisSymptoms?.date ? (
              <div style={{ display: 'flex', flexDirection: 'column' }}>{formatPartialDate(mgravisSymptoms?.date)}</div>
            ) : (
              ' - '
            )
          }
        />

        <HistoryRowVerticalItem header={fm('diagnosis.mgravis.symptoms.age')} value={mgravisSymptoms?.age} />

        <HistoryRowVerticalItem
          header={fm('diagnosis.mgravis.symptoms.location')}
          value={
            mgravisSymptoms?.symptomLocation?.length
              ? mgravisSymptoms?.symptomLocation.map((item: string) => fm('diagnosis.mgravis.symptoms.' + item))
              : ' - '
          }
        />
      </React.Fragment>
    </HistorySection>
  );
};

export default MgravisSymptoms;
